import DOMPurify from 'dompurify';
import LnIcon from 'src/components/LnIcon';
import { useAlert } from 'src/components/Modalservice/UseAlert';
import { NotificationViewDto } from 'src/services/user/types';
import { useI18n } from 'src/utils/lni18n';
import classes from './home.module.scss';
import { Card, CardBody } from 'reactstrap';

export const NotificationItem: React.FC<{ item: NotificationViewDto, onSetAsRead?: (id: string) => void }>
    = ({ item, onSetAsRead }) => {

        const { languageService: t } = useI18n();
        const alert = useAlert();

        const itemClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
            event.preventDefault();
            event.stopPropagation();

            alert("lg",
                item.Header,
                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.Html) }}></div>
            ).then(() => {
                onSetAsRead && onSetAsRead(item.Id);
            });

        }

        return (
            <>

                <Card className={classes.notificationCard + " pointer"} onClick={(e) => itemClick(e)}>

                    <CardBody>

                        <div className={[classes.messageItem, classes[item.DisplayType]].join(' ')}>
                            <div className="d-flex">
                                <small>
                                    <LnIcon className="mr-4 icon-medium" name="calendar-icon" />
                                    {t.getShortDateString(item.StartDate)}
                                    {item.NewForUser &&
                                        <div className="ml-4 rounded-circle d-inline-block bg-warning p-2 px-3">
                                            <LnIcon name="bell-icon" className="icon-small filter-white" />
                                        </div>
                                    }

                                </small>

                                <div className="ml-auto badge badge-pill">{item.Author.FullName}</div>
                            </div>
                            <div   >
                                <div>
                                    <strong>{item.Header}</strong>
                                </div>
                                <div className={['mt-1', classes.messageText].join(' ')} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.Message) }}></div>
                            </div>

                        </div>
                    </CardBody>

                </Card>

            </>

        )
    }
